import styled from 'styled-components';

import { TipsStatementSection } from '../model';

import { TipsStatementSectionBlock } from './tips-statement-section-block';

type TipsStatementSectionListProps = {
  sections: TipsStatementSection[];
};

const Sections = styled.div.attrs({
  'data-ui': 'tips-statement-section-list',
})`
  display: grid;
  align-content: start;
  gap: ${({ theme }) => theme.scale.px(24)};
`;

export function TipsStatementSectionList({
  sections,
}: TipsStatementSectionListProps) {
  return (
    <Sections>
      {sections.map(section => (
        <TipsStatementSectionBlock key={section.id} section={section} />
      ))}
    </Sections>
  );
}
